import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="mx-auto flex w-full max-w-3xl flex-col items-center px-4 py-24 text-center md:px-6">
      <p className="font-heading text-6xl font-bold text-primary-200 md:text-8xl">404</p>
      <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950">
        页面走丢了
      </h1>
      <p className="mt-2 text-sm text-foreground-500">
        你访问的页面可能已被移动或不存在，不妨回到首页继续查找字幕资源。
      </p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line text-lg"></i>
          返回首页
        </Link>
        <Link
          to="/search"
          className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300"
        >
          <i className="ri-search-line text-lg"></i>
          搜索字幕
        </Link>
      </div>
    </div>
  );
}